// import { Component, OnInit, ViewChild } from '@angular/core';
// import {
//   MatPaginator, MatTableDataSource,
//   MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSort
// } from '@angular/material';
// import { OrderService } from '../../services/order/order.service';
// import { PdfgeneratorService } from '../../services/pdfgenerator/pdfgenerator.service';
// import { ExcelgeneratorService } from '../../services/excelgenerator/excelgenerator.service';
// import html2canvas from 'html2canvas';
// import { DatePipe } from '@angular/common';
// import { NgxDateRangePickerOptions } from '../../../ngx-daterangepicker';
// import { Subscription, Subject } from 'rxjs';
// import { takeUntil } from 'rxjs/operators';
// import { AllorderdetailsComponent } from '../order/allorderdetails/allorderdetails.component';
// import { TokenStorage } from '../../auth/token.storage';
// import { UploadfileService } from 'src/app/services/uploadfile/uploadfile.service';

// @Component({
//   selector: 'app-orderreport',
//   templateUrl: './orderreport.component.html',
//   styleUrls: ['./orderreport.component.scss']
// })
// export class OrderreportComponent implements OnInit {
//   columnsToDisplay = [
//     'invoice',
//     'origin',
//     'createdOn',
//     'status',
//     'receiver',
//     'deliveredby',
//     'deliveredon',
//     'productName',
//     'serialno',
//     'rating',
//     'pod',
//   ];
//   selected = '90';
//   options: NgxDateRangePickerOptions;
//   orderDataArray = new MatTableDataSource();
//   page: number = 0;
//   excelRecords = [];
//   totalRecords: number = 0;
//   range = [1, 2, 3, 4, 5];
//   daterRangevalue: any;
//   fromDate: any;
//   toDate: any;
//   isDateFiltered: boolean = false;
//   orders = [];
//   selectedValue = [];
//   isLoading = true;
//   prevFromDate: any;
//   prevTodate: any;
//   protected ngUnsubscribe: Subject<void> = new Subject<void>();
//   isTenantDiag: boolean = false;
//   @ViewChild(MatSort) sort: MatSort;
//   @ViewChild(MatPaginator) paginator: MatPaginator;
//   filename: any;
//   subscription: Subscription;
//   isFileUploading: boolean = false;
//   fileName: any;
//   disableApply: boolean = false;
//   constructor(public orderService: OrderService,
//     public generatePdf: PdfgeneratorService,
//     public excelService: ExcelgeneratorService,
//     public datePipe: DatePipe,
//     public dialog: MatDialog,
//     private token: TokenStorage,
//     private uploadService: UploadfileService
//   ) {

//   }

//   ngOnInit() {
//     this.createInitialFilter();
//     if (this.token.getCustomerType() === 'Diagnostic') {
//       this.isTenantDiag = true;
//     }
//     this.subscription = this.uploadService.event.subscribe(() => {
//       this.isFileUploading = false;
//     });
//   }

//   ngAfterViewInit() {
//     this.orderDataArray.paginator = this.paginator;
//   }

//   exportAsXLSX() {
//     let ordersData = [];
//     console.log(ordersData)
//     ordersData = this.orders;
//     this.excelRecords = [];
//     ordersData.forEach(order => {
//       // Added By Digvijay
//       if(order == null){
//         console.log("order details not found");
//       }
//       if(order != null){ // Added by Digvijay
//         let createdOn, delivereddate, orderstatus, driver, vehicle, comments, dispatchDate, feedbackRating;
//         if (order) {

//           if (order.created_on)
//             createdOn = this.datePipe.transform(order.created_on, "mediumDate");
//           else
//             createdOn = '-----'

//           if (order.delivered_on)
//             delivereddate = this.datePipe.transform(order.delivered_on, "medium");
//           else
//             delivereddate = '-----'

//           if (order.dispatchDate)
//             dispatchDate = this.datePipe.transform(order.dispatchDate, "mediumDate");
//           else
//             dispatchDate = '-----'

//           if (order.driver)
//             driver = order.driver;
//           else
//             driver = '-----'

//           if (order.vehicle)
//             vehicle = ', ' + order.vehicle;
//           else
//             vehicle = ''

//           if (order.feedbackComments)
//             comments = ', ' + order.feedbackComments;
//           else
//             comments = ''

//           if (order.feedback_rating)
//             feedbackRating = order.feedback_rating;
//           else
//             feedbackRating = ''

//           orderstatus = order.orderstatus.slice(12);
//         }
//         this.excelRecords.push({
//           'Order': order.invoice_number || '',
//           'Billing From': order.originated_from,
//           'Delivery From': order.dispatched_from,
//           'Created On': createdOn,
//           'Dispatched On': dispatchDate,
//           'Status': orderstatus = order ? order.orderstatus.slice(12) : '',
//           'Reason': order.failedReason || '',
//           'Customer': order.receiver_name || '',
//           'Address': order.destination_address || '',
//           'Pincode': order.destination_address_pincode || '',
//           'Driver': driver || '',
//           'Vehicle': vehicle || '',
//           'Delivered On': delivereddate,
//           'Product Name': order.productName || '',
//           'Product Quantity': order.total_productQty || 0,
//           'Product Category': order.productCategory || '',
//           'Serial No.': order.serial_numbers || '',
//           'Customer rating': feedbackRating,
//           'Comments': comments || '',
//           'POD Available': order ? order.pod_image_exists : '',
//         })
//       }
//     });
//     this.excelService.exportAsExcelFile(this.excelRecords, 'orderreport');

//   }

//   public captureScreen() {
//     var data = document.getElementById('contentToConvert');
//     html2canvas(data).then(canvas => {
//       this.generatePdf.pdfgenerator(canvas, this.orderDataArray.data.length);
//     });
//   }

//   public isMarked = (index, score) => {
//     if (score >= index + 1) {
//       return 'fa-star';
//     }
//     else {
//       return 'fa-star-o';
//     }
//   }

//   createInitialFilter() {
//     this.options = {
//       theme: 'default',
//       labels: ['Start', 'End'],
//       menu: null,
//       dateFormat: 'YYYY-MM-DD',
//       outputFormat: 'DD-MM-YYYY',
//       startOfWeek: 1,
//       outputType: 'object',
//       locale: 'en',
//       date: {
//         from: {
//           year: new Date().getFullYear(),
//           month: new Date().getMonth() + 1,
//           day: new Date().getDate()
//         },
//         to: {
//           year: new Date().getFullYear(),
//           month: new Date().getMonth() + 1,
//           day: new Date().getDate()
//         }
//       }
//     };
//     this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
//     this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
//     this.selectedValue = [];
//     this.orderFilter();
//   }

//   orderFilter() {
//     this.orderDataArray.data = [];
//     this.orders = [];
//     this.isLoading = true;
//     this.getData(this.fromDate, this.toDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(orders => {
//       this.isLoading = false;
//       console.log("orders in report", orders);
//       // this.dataForExcel(orders);
//       this.orderDataArray.data = orders.filter(order => order);
//       this.orders = orders;
//       this.orderDataArray.sortingDataAccessor = (item: any, property) => {
//         switch (property) {
//           case 'invoice': return item.invoice_number;
//           case 'dispatchDate': return item.dispatchDate;
//           case 'status': return item.orderstatus;
//         }
//       };
//       this.orderDataArray.sort = this.sort;
//       if (this.selectedValue.length > 0)
//         this.sortByState();
//     })
//   }

//   deleteDuplicateOrders() {
//     this.orderDataArray.data = [];
//     this.orders = [];
//     this.isLoading = true;
//     this.deleteDuplicates(this.fromDate, this.toDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(orders => {
//       this.isLoading = false;
//       console.log("orders in report", orders);
//       // this.dataForExcel(orders);
//       this.orderDataArray.data = orders.filter(order => order);
//       this.orders = orders;
//       this.orderDataArray.sortingDataAccessor = (item: any, property) => {
//         switch (property) {
//           case 'invoice': return item.invoice_number;
//           case 'dispatchDate': return item.dispatchDate;
//           case 'status': return item.orderstatus;
//         }
//       };
//       this.orderDataArray.sort = this.sort;
//       if (this.selectedValue.length > 0)
//         this.sortByState();
//     })
//   }

//   getData(from, to) {
//     let orderStates = ['ORDER_STATE_UNPLANNED', 'ORDER_STATE_IN_PLANNING', 'ORDER_STATE_SCHEDULED', 'ORDER_STATE_IN_TRANSIT', 'ORDER_STATE_FAILED', 'ORDER_STATE_DELIVERED', 'ORDER_STATE_SCHEDULED_FOR_PICKUP','ORDER_STATE_INITIAL']
//     return this.orderService.getOrderReportByStates(from, to, orderStates);
//   }

//   deleteDuplicates(from, to) {
//     let orderStates = ['ORDER_STATE_UNPLANNED', 'ORDER_STATE_IN_PLANNING', 'ORDER_STATE_SCHEDULED', 'ORDER_STATE_IN_TRANSIT', 'ORDER_STATE_FAILED', 'ORDER_STATE_DELIVERED', 'ORDER_STATE_SCHEDULED_FOR_PICKUP','ORDER_STATE_INITIAL']
//     return this.orderService.deleteDuplicateOrders(from, to, orderStates);
//   }

//   deleteDuplicateOrdersByDate() {
//     if (!this.daterRangevalue) {
//       console.log(this.daterRangevalue, this.selectedValue);
//       this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
//       this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
//       this.deleteDuplicateOrders();
//       this.prevFromDate = this.fromDate;
//       this.prevTodate = this.toDate;
//     }

//     else if (this.daterRangevalue) {
//       this.fromDate = this.daterRangevalue.from.substring(6, 10) + '-' + this.daterRangevalue.from.substring(3, 5) + '-' + this.daterRangevalue.from.substring(0, 2);
//       this.toDate = this.daterRangevalue.to.substring(6, 10) + '-' + this.daterRangevalue.to.substring(3, 5) + '-' + this.daterRangevalue.to.substring(0, 2);
//       if (this.toDate != this.prevTodate || this.fromDate != this.prevFromDate) {
//         this.ngUnsubscribe.next();
//         this.isDateFiltered = true;
//         this.deleteDuplicateOrders();
//         this.prevFromDate = this.fromDate;
//         this.prevTodate = this.toDate;
//       }
//     }
//   }

//   sortByDate() {
//     if (!this.daterRangevalue) {
//       console.log(this.daterRangevalue, this.selectedValue);
//       this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
//       this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
//       this.orderFilter();
//       this.prevFromDate = this.fromDate;
//       this.prevTodate = this.toDate;
//     }

//     else if (this.daterRangevalue) {
//       this.fromDate = this.daterRangevalue.from.substring(6, 10) + '-' + this.daterRangevalue.from.substring(3, 5) + '-' + this.daterRangevalue.from.substring(0, 2);
//       this.toDate = this.daterRangevalue.to.substring(6, 10) + '-' + this.daterRangevalue.to.substring(3, 5) + '-' + this.daterRangevalue.to.substring(0, 2);
//       if (this.toDate != this.prevTodate || this.fromDate != this.prevFromDate) {
//         this.ngUnsubscribe.next();
//         this.isDateFiltered = true;
//         this.orderFilter();
//         this.prevFromDate = this.fromDate;
//         this.prevTodate = this.toDate;
//       }
//     }
//   }


//   clearAllFilter() {
//     this.paginator.pageIndex = 0;
//     this.createInitialFilter();
//     this.isDateFiltered = false;
//   }

//   orderDetails(orderid) {
//     let editDialog = this.dialog.open(AllorderdetailsComponent, {
//       width: '800px',
//       data: {
//         orderId: orderid,
//         component: 'orderReport'
//       }
//     });
//     editDialog.updatePosition({
//       top: '50px', right: '0px',
//     });
//   }

//   sortByState() {
//     let newres = [];
//     if (this.selectedValue.length > 0) {
//       for (let i = 0; i < this.orders.length; i++) {
//         let custZone;
//         if (this.orders[i] && this.orders[i].orderstatus)
//           custZone = this.orders[i].orderstatus;
//         this.selectedValue.forEach(selectedZone => {
//           if (custZone === selectedZone) {
//             newres.push(this.orders[i]);
//           }
//         });
//       }
//       this.orderDataArray.data = newres;
//       //  this.dataForExcel(newres);
//     }
//     else {
//       this.orderDataArray.data = this.orders;
//       // this.dataForExcel(this.orders);
//     }
//   }

//   applyFilter(filterValue: string) {
//     this.orderDataArray.filter = filterValue.trim().toLowerCase();
//   }

//   submitFile(fileEvent) {
//     if (fileEvent) {
//       this.filename = fileEvent.target.files[0].name;
//       console.log(fileEvent.target.files[0]);
//       if (fileEvent.target.files.length > 0) {
//         this.isFileUploading = true;
//         const file: File = fileEvent.target.files[0];
//         this.uploadService.searchInvoices(file);
//       }
//     }
//   }

//   checkDays() {
//     console.log(this.daterRangevalue)
//     let oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
//     if (this.daterRangevalue && this.daterRangevalue.to && this.daterRangevalue.from) {
//       let firstDate: any = new Date(this.daterRangevalue.to.substring(6, 10), (this.daterRangevalue.to.substring(3, 5) - 1), this.daterRangevalue.to.substring(0, 2));
//       let secondDate: any = new Date(this.daterRangevalue.from.substring(6, 10), (this.daterRangevalue.from.substring(3, 5) - 1), this.daterRangevalue.from.substring(0, 2));

//       const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
//       console.log(diffDays, firstDate, secondDate)
//       if(diffDays>30){
//         this.disableApply = true;
//       }
//       else{
//         this.disableApply = false;
//       }
//     }
//   }
// }


import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSort
} from '@angular/material';
import { OrderService } from '../../services/order/order.service';
import { PdfgeneratorService } from '../../services/pdfgenerator/pdfgenerator.service';
import { ExcelgeneratorService } from '../../services/excelgenerator/excelgenerator.service';
import html2canvas from 'html2canvas';
import { DatePipe } from '@angular/common';
import { NgxDateRangePickerOptions } from '../../../ngx-daterangepicker';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AllorderdetailsComponent } from '../order/allorderdetails/allorderdetails.component';
import { TokenStorage } from '../../auth/token.storage';
import { UploadfileService } from 'src/app/services/uploadfile/uploadfile.service';

@Component({
  selector: 'app-orderreport',
  templateUrl: './orderreport.component.html',
  styleUrls: ['./orderreport.component.scss']
})
export class OrderreportComponent implements OnInit {
  columnsToDisplay = [
    'invoice',
    'origin',
    'createdOn',
    'status',
    'receiver',
    'deliveredby',
    'deliveredon',
    'productName',
    'serialno',
    'rating',
    'pod',
  ];
  selected = '90';
  options: NgxDateRangePickerOptions;
  orderDataArray = new MatTableDataSource();
  page: number = 0;
  excelRecords = [];
  totalRecords: number = 0;
  range = [1, 2, 3, 4, 5];
  daterRangevalue: any;
  fromDate: any;
  toDate: any;
  isDateFiltered: boolean = false;
  orders = [];
  selectedValue = [];
  isLoading = true;
  prevFromDate: any;
  prevTodate: any;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  isTenantDiag: boolean = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filename: any;
  subscription: Subscription;
  isFileUploading: boolean = false;
  fileName: any;
  disableApply: boolean = false;
  constructor(public orderService: OrderService,
    public generatePdf: PdfgeneratorService,
    public excelService: ExcelgeneratorService,
    public datePipe: DatePipe,
    public dialog: MatDialog,
    private token: TokenStorage,
    private uploadService: UploadfileService
  ) {

  }

  ngOnInit() {
    this.createInitialFilter();
    if (this.token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;
    }
    this.subscription = this.uploadService.event.subscribe(() => {
      this.isFileUploading = false;
    });
  }

  ngAfterViewInit() {
    this.orderDataArray.paginator = this.paginator;
  }

  exportAsXLSX() {
    let ordersData = [];
    console.log(ordersData)
    ordersData = this.orders;
    this.excelRecords = [];
    ordersData.forEach(order => {
      // Added By Digvijay
      if(order == null){
        console.log("order details not found");
      }
      if(order != null){ // Added by Digvijay
        let createdOn, delivereddate, orderstatus, driver, vehicle, comments, dispatchDate, feedbackRating;
        if (order) {

          if (order.created_on)
            createdOn = this.datePipe.transform(order.created_on, "mediumDate");
          else
            createdOn = '-----'

          if (order.delivered_on)
            delivereddate = this.datePipe.transform(order.delivered_on, "medium");
          else
            delivereddate = '-----'

          if (order.dispatchDate)
            dispatchDate = this.datePipe.transform(order.dispatchDate, "mediumDate");
          else
            dispatchDate = '-----'

          if (order.driver)
            driver = order.driver;
          else
            driver = '-----'

          if (order.vehicle)
            vehicle = ', ' + order.vehicle;
          else
            vehicle = ''

          if (order.feedbackComments)
            comments = ', ' + order.feedbackComments;
          else
            comments = ''

          if (order.feedback_rating)
            feedbackRating = order.feedback_rating;
          else
            feedbackRating = ''

          orderstatus = order.orderstatus.slice(12);
        }
        this.excelRecords.push({
          'Order': order.invoice_number || '',
          'Billing From': order.originated_from,
          'Delivery From': order.dispatched_from,
          'Created On': createdOn,
          'Dispatched On': dispatchDate,
          'Status': orderstatus = order ? order.orderstatus.slice(12) : '',
          'Reason': order.failedReason || '',
          'Customer': order.receiver_name || '',
          'Address': order.destination_address || '',
          'Pincode': order.destination_address_pincode || '',
          'Driver': driver || '',
          'Vehicle': vehicle || '',
          'Delivered On': delivereddate,
          'Product Name': order.productName || '',
          'Product Quantity': order.total_productQty || 0,
          'Product Category': order.productCategory || '',
          'Serial No.': order.serial_numbers || '',
          'Customer rating': feedbackRating,
          'Comments': comments || '',
          'POD Available': order ? order.pod_image_exists : '',
        })
      }
    });
    this.excelService.exportAsExcelFile(this.excelRecords, 'orderreport');

  }

  public captureScreen() {
    var data = document.getElementById('contentToConvert');
    html2canvas(data).then(canvas => {
      this.generatePdf.pdfgenerator(canvas, this.orderDataArray.data.length);
    });
  }

  public isMarked = (index, score) => {
    if (score >= index + 1) {
      return 'fa-star';
    }
    else {
      return 'fa-star-o';
    }
  }

  createInitialFilter() {
    this.options = {
      theme: 'default',
      labels: ['Start', 'End'],
      menu: null,
      dateFormat: 'YYYY-MM-DD',
      outputFormat: 'DD-MM-YYYY',
      startOfWeek: 1,
      outputType: 'object',
      locale: 'en',
      date: {
        from: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        },
        to: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        }
      }
    };
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.selectedValue = [];
    this.orderFilter();
  }

  orderFilter() {
    this.orderDataArray.data = [];
    this.orders = [];
    this.isLoading = true;
    this.getData(this.fromDate, this.toDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(orders => {
      this.isLoading = false;
      console.log("orders in report", orders);
      // this.dataForExcel(orders);
      this.orderDataArray.data = orders.filter(order => order);
      this.orders = orders;
      this.orderDataArray.sortingDataAccessor = (item: any, property) => {
        switch (property) {
          case 'invoice': return item.invoice_number;
          case 'dispatchDate': return item.dispatchDate;
          case 'status': return item.orderstatus;
        }
      };
      this.orderDataArray.sort = this.sort;
      if (this.selectedValue.length > 0)
        this.sortByState();
    })
  }

  deleteDuplicateOrders() {
    this.orderDataArray.data = [];
    this.orders = [];
    this.isLoading = true;
    this.deleteDuplicates(this.fromDate, this.toDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(orders => {
      this.isLoading = false;
      console.log("orders in report", orders);
      // this.dataForExcel(orders);
      this.orderDataArray.data = orders.filter(order => order);
      this.orders = orders;
      this.orderDataArray.sortingDataAccessor = (item: any, property) => {
        switch (property) {
          case 'invoice': return item.invoice_number;
          case 'dispatchDate': return item.dispatchDate;
          case 'status': return item.orderstatus;
        }
      };
      this.orderDataArray.sort = this.sort;
      if (this.selectedValue.length > 0)
        this.sortByState();
    })
  }

  getData(from, to) {
    let orderStates = ['ORDER_STATE_UNPLANNED', 'ORDER_STATE_IN_PLANNING', 'ORDER_STATE_SCHEDULED', 'ORDER_STATE_IN_TRANSIT', 'ORDER_STATE_FAILED', 'ORDER_STATE_DELIVERED', 'ORDER_STATE_SCHEDULED_FOR_PICKUP','ORDER_STATE_INITIAL']
    return this.orderService.getOrderReportByStates(from, to, orderStates);
  }

  deleteDuplicates(from, to) {
    let orderStates = ['ORDER_STATE_UNPLANNED', 'ORDER_STATE_IN_PLANNING', 'ORDER_STATE_SCHEDULED', 'ORDER_STATE_IN_TRANSIT', 'ORDER_STATE_FAILED', 'ORDER_STATE_DELIVERED', 'ORDER_STATE_SCHEDULED_FOR_PICKUP','ORDER_STATE_INITIAL']
    return this.orderService.deleteDuplicateOrders(from, to, orderStates);
  }

  deleteDuplicateOrdersByDate() {
    if (!this.daterRangevalue) {
      console.log(this.daterRangevalue, this.selectedValue);
      this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.deleteDuplicateOrders();
      this.prevFromDate = this.fromDate;
      this.prevTodate = this.toDate;
    }

    else if (this.daterRangevalue) {
      this.fromDate = this.daterRangevalue.from.substring(6, 10) + '-' + this.daterRangevalue.from.substring(3, 5) + '-' + this.daterRangevalue.from.substring(0, 2);
      this.toDate = this.daterRangevalue.to.substring(6, 10) + '-' + this.daterRangevalue.to.substring(3, 5) + '-' + this.daterRangevalue.to.substring(0, 2);
      if (this.toDate != this.prevTodate || this.fromDate != this.prevFromDate) {
        this.ngUnsubscribe.next();
        this.isDateFiltered = true;
        this.deleteDuplicateOrders();
        this.prevFromDate = this.fromDate;
        this.prevTodate = this.toDate;
      }
    }
  }

  sortByDate() {
    if (!this.daterRangevalue) {
      console.log(this.daterRangevalue, this.selectedValue);
      this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.orderFilter();
      this.prevFromDate = this.fromDate;
      this.prevTodate = this.toDate;
    }

    else if (this.daterRangevalue) {
      this.fromDate = this.daterRangevalue.from.substring(6, 10) + '-' + this.daterRangevalue.from.substring(3, 5) + '-' + this.daterRangevalue.from.substring(0, 2);
      this.toDate = this.daterRangevalue.to.substring(6, 10) + '-' + this.daterRangevalue.to.substring(3, 5) + '-' + this.daterRangevalue.to.substring(0, 2);
      if (this.toDate != this.prevTodate || this.fromDate != this.prevFromDate) {
        this.ngUnsubscribe.next();
        this.isDateFiltered = true;
        this.orderFilter();
        this.prevFromDate = this.fromDate;
        this.prevTodate = this.toDate;
      }
    }
  }


  clearAllFilter() {
    this.paginator.pageIndex = 0;
    this.createInitialFilter();
    this.isDateFiltered = false;
  }

  orderDetails(orderid) {
    let editDialog = this.dialog.open(AllorderdetailsComponent, {
      width: '800px',
      data: {
        orderId: orderid,
        component: 'orderReport'
      }
    });
    editDialog.updatePosition({
      top: '50px', right: '0px',
    });
  }

  sortByState() {
    let newres = [];
    if (this.selectedValue.length > 0) {
      for (let i = 0; i < this.orders.length; i++) {
        let custZone;
        if (this.orders[i] && this.orders[i].orderstatus)
          custZone = this.orders[i].orderstatus;
        this.selectedValue.forEach(selectedZone => {
          if (custZone === selectedZone) {
            newres.push(this.orders[i]);
          }
        });
      }
      this.orderDataArray.data = newres;
      //  this.dataForExcel(newres);
    }
    else {
      this.orderDataArray.data = this.orders;
      // this.dataForExcel(this.orders);
    }
  }

  applyFilter(filterValue: string) {
    this.orderDataArray.filter = filterValue.trim().toLowerCase();
  }

  submitFile(fileEvent) {
    debugger;
    if (fileEvent) {
      console.log("Selected file: ", fileEvent.target.files[0]);
      this.filename = fileEvent.target.files[0].name;
      if (fileEvent.target.files.length > 0) {
        const file: File = fileEvent.target.files[0];
         
        this.uploadService.searchInvoices(file);
      }
    }
  }
  

  checkDays() {
    console.log(this.daterRangevalue)
    let oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    if (this.daterRangevalue && this.daterRangevalue.to && this.daterRangevalue.from) {
      let firstDate: any = new Date(this.daterRangevalue.to.substring(6, 10), (this.daterRangevalue.to.substring(3, 5) - 1), this.daterRangevalue.to.substring(0, 2));
      let secondDate: any = new Date(this.daterRangevalue.from.substring(6, 10), (this.daterRangevalue.from.substring(3, 5) - 1), this.daterRangevalue.from.substring(0, 2));

      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
      console.log(diffDays, firstDate, secondDate)
      if(diffDays>30){
        this.disableApply = true;
      }
      else{
        this.disableApply = false;
      }
    }
  }
}
